/**
 * @desc 查询所有平台
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlatformResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/platform/selectAll`, {
      method: "GET",

      ...options,
    }),
  );
}
